<template>
	<div>
		<LoadingSpinner v-if="loading" />
		<div v-else class="row">
			<div class="col-12">
				<b-alert v-if="expeditions.length === 0" variant="info" show>
					{{ $t('monte.congelation.aucune_expeditions') }}
				</b-alert>

				<table v-else class="table table-hover table-sm mb-0">
					<thead class="sticky">
						<tr>
							<th>{{ $t('monte.congelation.date_expedition') }}</th>
							<th>{{ $t('monte.congelation.destinataire') }}</th>
							<th>{{ $t('monte.congelation.qte') }}</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="expedition in expeditions" :key="expedition.semenceexpedition_id">
							<td>{{ formatDate(expedition.semenceexpedition_expedition_date) }}</td>
							<td>
								<router-link v-if="expedition.destinataire" :to="{ name: 'tiersFiche', params: { tiers_id: expedition.destinataire.tiers_id }}"><tiers-moral-icon :moral="expedition.destinataire.tiers_moral" />{{ expedition.destinataire.tiers_rs }}</router-link>
							</td>
							<td>{{ expedition.semenceexpedition_qte }} {{ $t('monte.paillettes') }}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script type="text/javascript">
	import Congelation from "@/mixins/Congelation.js"

	export default {
		name: 'ExpeditionHistorique',
		mixins: [Congelation],
		props: ['lot'],
		data () {
			return {
				loading: false,
				expeditions: []
			}
		},

		mounted() {
			this.init_component()
		},

		methods: {
			async init_component() {
				this.loading = true
				this.expeditions = await this.getExpeditionsByLot(this.lot.semencelot_id)
				this.loading = false
			}
		},

		components: {
			LoadingSpinner: () => import('GroomyRoot/components/Logos/LoadingSpinner_35')
		}
	}

</script>
